import { User, UserRole, UserStatus } from '../types';
import { apiClient } from 'api/apiClient';

export type CreateUsersReqData = {
  name: string;
  email: string;
  role: UserRole;
};

export type UpdateUserReqData = {
  name?: string;
  email?: string;
  role?: UserRole;
  status?: UserStatus;
};

export type Credentials = {
  clientId: string;
  clientSecret: string;
};

const SERVICE_PATH = '/us';

const getPath = (path = '', isPublic = false) => {
  return `${apiClient.getPath(SERVICE_PATH, isPublic)}${apiClient.Paths.USERS}${path}`;
};

const getUser = async (userId: string) => {
  const res = await apiClient.apiInstance.get(getPath('/' + userId));
  return res.data as User;
};

const getCurrentUser = async () => {
  const res = await apiClient.apiInstance.get(getPath('/me'));
  return res.data as User;
};

const getUsers = async () => {
  const res = await apiClient.apiInstance.get(getPath());
  return res.data as User[];
};

const verifyUser = (userId: string) => apiClient.apiInstance.post(getPath(`/verify/${userId}`, true));

const createUser = (userData: CreateUsersReqData) => apiClient.apiInstance.post(getPath(), userData);

const resendInvite = (userId: string) => apiClient.apiInstance.post(getPath(`/${userId}/resend-invitation-email`));

const updateUser = (userData: UpdateUserReqData, userID: string) =>
  apiClient.apiInstance.patch(getPath('/' + userID), userData);

const deleteUser = (userID: string) => apiClient.apiInstance.delete(getPath('/' + userID));

const getCredentials = async (userID: string) => {
  const res = await apiClient.apiInstance.get(getPath('/' + userID + '/api-credentials'));
  return res.data as Credentials;
};

const updateCredentials = async (userID: string) => {
  const res = await apiClient.apiInstance.post(getPath('/' + userID + '/api-credentials'));
  return res.data as Credentials;
};

const checkEmail = async (email: string) => {
  const res = await apiClient.apiInstance.head(getPath(`/${email}`, true));
  return res.data;
};

export const userService = {
  updateUser,
  getUsers,
  verifyUser,
  createUser,
  getUser,
  getCurrentUser,
  resendInvite,
  deleteUser,
  getCredentials,
  updateCredentials,
  checkEmail,
};
